import * as Styled from './PublishBar.styles'
import { Button } from '@mui/material'
import { DeleteSweepOutlined as DeleteSweepOutlinedIcon } from '@mui/icons-material'

interface PublishBarProps {
  onClear: () => void
  onSave: () => void
  saveDisabled?: boolean
}

const PublishBar = ({ onClear, onSave, saveDisabled }: PublishBarProps) => {
  return (
    <Styled.ButtonContainer>
      <Styled.ButtonInnerContainer>
        <Button
          variant="text"
          startIcon={<DeleteSweepOutlinedIcon />}
          onClick={onClear}
        >
          Clear
        </Button>
        <Button variant="outlined" onClick={onSave} disabled={saveDisabled}>
          Save Poll
        </Button>
      </Styled.ButtonInnerContainer>
    </Styled.ButtonContainer>
  )
}

export default PublishBar
